import { FiShare2 } from "react-icons/fi";

interface ShareClipButtonProps {
  placement: "card" | "modal";
  onShare: () => void;
}

export function ShareClipButton({ placement, onShare }: ShareClipButtonProps) {
  return (
    <button
      type="button"
      className={`clip-share-button clip-share-${placement}`}
      onClick={onShare}
      aria-label="Copy playable video link"
      title="Copy playable video link"
    >
      <FiShare2 aria-hidden="true" />
      {placement === "modal" && <span>Share</span>}
    </button>
  );
}
